import React from 'react';
import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from '../contexts/AuthContext';
import TopNav from './TopNav';

export default function Layout() {
  return (
    <ProtectedRoute>
      <TopNav />
      <main className="layout-main">
        <Outlet />
      </main>
    </ProtectedRoute>
  );
}
